import { gql } from '@apollo/client'

export const ENTITY_LIST_QUERY = gql`
  query EntityList($entityType: EntityType!) {
    entityList(entityType: $entityType) {
      value
      label
      entityCode
      displayEntityCode
      id
    }
  }
`
